export const WELCOME_SCREEN_PAGE_LOADED = 'welcome-screen-page-loaded';
export const WELCOME_SCREEN_LETS_GO_BUTTON_CLICKED = 'welcome-screen-lets-go-button-clicked';
